<div class="form-group tab-input input-icon-wrapper">
  <label *ngIf="to.label">{{ to.label }}</label>
  <span class="input-icon-text">
    <i [ngClass]="to['iconClass'] || 'fa-regular fa-user'"></i>
  </span>
  <ng-container #fieldComponent></ng-container>
</div>
